export default function debounce (func: (...args: unknown[]) => unknown, wait = 50) {
	let timeout: number | null;

	return () => {
		const callNow = !timeout;

		if (timeout != null) {
			clearTimeout(timeout);
		}

		timeout = window.setTimeout(() => {
			timeout = null;
			func();
		}, wait);

		if (callNow) {
			func();
		}
	};
}
